module.exports = __webpack_public_path__ + "static/media/join_algorithm.3c02a00d.png";